<template>
	<div>
		<section id="page-title">
			<div class="container clearfix">
				<h1>Schedule</h1>
				<span>2023 - 2024</span>
			</div>
		</section>
		<section id="content">
			<div class="table-full">
				<div class="postcontent clearfix">
					<img src="@/assets/img/ids_logo85px.png" />
					<table id="printableArea" class="table">
						<thead>
							<tr style="background: #f9a2c3">
								<th class="center" rowspan="2">TIME</th>
								<th class="center" colspan="4">MONDAY</th>
								<th class="center" colspan="4">TUESDAY</th>
								<th class="center" colspan="4">WEDNESDAY</th>
								<th class="center" colspan="4">THURSDAY</th>
								<th class="center" colspan="3">FRIDAY</th>
								<th class="center" colspan="4">SATURDAY</th>
							</tr>
						</thead>
						<tbody>
							<tr style="background: #ffe4ee; width: 200px">
								<td><b>STUDIO</b></td>
								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>
								<td class="table-cell">4</td>

								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>
								<td class="table-cell">4</td>

								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>
								<td class="table-cell">4</td>

								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>
								<td class="table-cell">4</td>

								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>

								<td class="table-cell">1</td>
								<td class="table-cell">2</td>
								<td class="table-cell">3</td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">4 PM</td>

								<!-- Monday -->
								<td class="center">Technique Minis</td>
								<td class="center">Private</td>
								<td class="center">Baby Ballet</td>
								<td class="center">Private</td>
								<!-- TUESDAY -->
								<td class="center">Private</td>
								<td class="center">Private</td>
								<td class="center">Jazz I</td>
								<td class="center">Private</td>
								<!-- WEDNESDAY -->
								<td class="center">Contemporary I</td>
								<td class="center">Private</td>
								<td class="center"></td>
								<td class="center">Private</td>
								<!-- THURSDAY -->
								<td class="center">Hip Hop I</td>
								<td class="center"></td>
								<td class="center"></td>
								<td class="center">Private</td>
								<td class="center">Classical Repertoire</td>
								<!-- FRIDAY -->
								<td class="center">Private</td>
								<td class="center">Private</td>
								<td></td>
								<td></td>
								<td></td>
							</tr>

							<tr>
								<td style="background: #ffe4ee">5 PM</td>
								<!-- MONDAY -->
								<td class="center">Technique Juniors</td>
								<td class="center">Private</td>
								<td class="center">Pre-Ballet</td>
								<td class="center">Private</td>
								<!-- TUESDAY -->
								<td class="center">Acro I A</td>
								<td class="center">Private</td>
								<td class="center">Jazz II</td>
								<td class="center">Private</td>
								<!-- WEDNESDAY -->
								<td class="center">Contemporary II</td>
								<td class="center">Private</td>
								<td class="center">Pre-Ballet</td>
								<td class="center">Private</td>
								<!-- THURSDAY -->
								<td class="center">Hip Hop III</td>
								<td class="center">Ballroom I</td>
								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<!-- FRIDAY -->
								<td class="center">Pointe I/II</td>
								<td class="center">Conditioning I</td>
								<td class="center">Private</td>

								<td></td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">6 PM</td>
								<!-- MONDAY -->
								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<td class="center">Ballet II</td>
								<td class="center">Private</td>
								<!-- TUESDAY -->
								<td class="center">Acro II</td>
								<td class="center">Ballet I</td>
								<td class="center">Jazz III/IV</td>
								<td class="center">Private</td>
								<!-- WEDNESDAY -->
								<td class="center">Contemporay III</td>
								<td class="center">Private</td>
								<td class="center">Ballet II</td>
								<td class="center">Private</td>
								<!-- THURSDAY -->
								<td class="center">Hip Hop II</td>
								<td class="center">Ballroom II</td>
								<td class="center">Ballet I</td>
								<td class="center">Private</td>
								<!-- FRIDAY -->
								<td class="center">IDS CO</td>
								<td class="center">Conditioning II</td>
								<td class="center">Private</td>
								<td></td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">7 PM</td>

								<td class="center">Technique Teens</td>
								<td class="center">Private</td>
								<td class="center">Ballet III/IV</td>
								<td class="center">Private</td>

								<td class="center">Acro III</td>
								<td class="center">Private</td>
								<td class="center">IDS CO</td>
								<td class="center">Private</td>

								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<td class="center">Ballet III</td>
								<td class="center">Private</td>

								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">8 PM</td>

								<td class="center">Junior small group</td>
								<td class="center">Private</td>
								<td class="center">Ballet V/ Ballet Co</td>
								<td class="center">Private</td>

								<td class="center">Acro IV</td>
								<td class="center">Private</td>
								<td class="center">Private</td>
								<td class="center">Private</td>

								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<td class="center">Ballet IV/V</td>
								<td class="center">Private</td>

								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">Private</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">10 AM</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td class="center">Acro I B</td>
								<td class="center">IDS CO</td>
								<td class="center">Baby Ballet</td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">11 AM</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">Pre-Ballet</td>
							</tr>
							<tr>
								<td style="background: #ffe4ee">12 PM</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td class="center">IDS CO</td>
								<td class="center">IDS CO</td>
								<td class="center">Private</td>
							</tr>
						</tbody>
					</table>
					<br />
					*** Physical/Conditioning Additional Fee $10
				</div>
				<p>Share this QR code to fast access to schedule</p>
				<img src="@/assets/img/qr-schedule.png" style="width: 200px" />
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Schedule',
	components: {},
}
</script>
